<template>
    <div :key="key" :class="[`cascader-custom`]">
        <el-cascader
            v-model="_value"
            :options="options"
            :props="props"
            collapse-tags
            clearable
        />
    </div>
</template>

<script>
export default {
  name: "CascaderCustom",


  props: {
    options: {
      type: Array,
      default() {
        return [];
      }
    },

    clearable:{
      type: Boolean,
      default: true
    },

    value:{
      type: Array,
      default: () => ([])
    }

  },

  data() {
    return {
      key: `InputCustomID-${Math.random()
        .toString(36)
        .slice(2)}`,

      props: { multiple: true }

    };
  },

  computed: {
    _value: {
      get() {
        return this.value;
      },
      set(val) {
        // console.log("value",val);
        this.$emit("input", val);
        this.$emit("change", val);
      }
    }
  },

  methods: {
    
  }
};
</script>

<style lang="scss">
.cascader-custom {
  display: inline-block;
}
.el-cascader{
  line-height: 32px;
  .el-cascader-menu{
    width: 150px;
    padding: 12px;
  }
}
</style>
